// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-8c6ec2f6]{margin-top:35px;font-size:14px;font-weight:400;color:#7c8b91}.flow-item[data-v-8c6ec2f6]{margin:12px 0;position:relative;padding:10px 10px 10px 15px;border-radius:6px;-webkit-box-shadow:0 0 3px 0 rgba(48,54,70,.1);box-shadow:0 0 3px 0 rgba(48,54,70,.1);border:1px solid #cfd8dc;background-color:#fff}", ""]);
// Exports
module.exports = exports;
